import { Asset, GeneralProject } from "../../interface/Server";
export interface State {
    formStep?: number
    nameplateInput?: string,
    messageInput?: string,
    selectedAsset?: Asset,
    selectedProject?: GeneralProject,
    user?: {},
    screen?: string,
    startTime?: Date,
    userName?: string
}

export const state: State = {
    formStep: undefined,
    nameplateInput: '',
    messageInput: '',
    user: {},
    screen: '',
    startTime: undefined,
    userName: ''
};

export default state;

